const Endpoints = {
    groups: {
        createOrUpdate: 'groups',
        getAll: (deleted) => `/groups?deleted=${deleted}`,
        deleteById: (grpId) => `/groups/${grpId}`,
        generateGroupId: (groupName) => `/groups/generate-id/${groupName}`
    },
    devices: {
        createOrUpdate: 'devices',
        getAll: (deleted) => `/devices?deleted=${deleted}`,
        deleteById: (slNo) => `/devices/${slNo}`,
        getByGroupId: (grpId) => `/devices-groups/${grpId}`,
        getByTerminalId: (slNo) => `/devices/${slNo}`,
        unmapControlConfig: (slNo) => `/devices/${slNo}/config/control`,
        fetchUnmapDevice: () => `/devices/unmapped`,
        bulkUpload: `/devices/bulk-upload`,
        clone: `/devices/clone`,
        restore: (slNo) => `/devices/${slNo}/restore`
    },
    controlConfig: {
        createReadUpdate: '/configs/control',
        deleteBySlNo: (controlSerialNumber) => `/configs/control/${controlSerialNumber}`,
        getByGrpId: (grpId) => `/configs/control/group/${grpId}`
    },
    terminalConfig: {
        createOrUpdate: '/configs/terminal',
        getByControlSlNo: (controlSerialNumber) => `/configs/terminal/${controlSerialNumber}`
    },
    transactionControl: {
        createOrUpdate: '/configs/transaction-control',
        getByControlSlNo: (controlSerialNumber) => `/configs/transaction-control/${controlSerialNumber}`
    },
    passwordConfig: {
        createOrUpdate: '/configs/transaction-password',
        getByControlSlNo: (controlSerialNumber) => `/configs/transaction-password/${controlSerialNumber}`
    },
    headerConfig: {
        createOrUpdate: '/configs/header',
        getByControlSlNo: (controlSerialNumber) => `/configs/header/control/${controlSerialNumber}`,
        deleteBySlNo: (slNo) => `/configs/header/${slNo}`
    },
    hostConfig: {
        createOrUpdate: '/configs/host',
        getByControlSlNo: (controlSerialNumber) => `/configs/host/control/${controlSerialNumber}`,
        deleteBySlNo: (slNo) => `/configs/host/${slNo}`
    },
    cardConfig: {
        createOrUpdate: '/configs/card',
        getByControlSlNo: (controlSerialNumber) => `/configs/card/${controlSerialNumber}`,
        deleteBySlNo: (slNo) => `/configs/card/${slNo}`
    },
    currencyConfig: {
        createOrUpdate: '/configs/currency',
        getByControlSlNo: (controlSerialNumber) => `/configs/currency/${controlSerialNumber}`,
        deleteBySlNo: (slNo) => `/configs/currency/${slNo}`
    },
    evmConfig: {
        createOrUpdate: '/configs/evm',
        getByControlSlNo: (controlSerialNumber) => `/configs/evm/${controlSerialNumber}`,
        deleteBySlNo: (slNo) => `/configs/evm/${slNo}`
    },
    capkConfig: {
        createOrUpdate: '/configs/capk',
        getByControlSlNo: (controlSerialNumber) => `/configs/capk/${controlSerialNumber}`,
        deleteBySlNo: (slNo) => `/configs/capk/${slNo}`
    },
    installmentConfig: {
        createOrUpdate: '/configs/installment',
        getByControlSlNo: (controlSerialNumber) => `/configs/installment/${controlSerialNumber}`,
        deleteBySlNo: (slNo) => `/configs/installment/${slNo}`
    },
    banksMaster: {
        getAll: '/banks/0/10'
    }
};

export default Endpoints;
